module.exports = __webpack_public_path__ + "media/images/lb/510-22605c5e636e5d6e5c55f572a7475ba9.svg";